<div class="ufp-dialog-overlay" (click)="onOverlayClick($event)">
  <div class="ufp-dialog-content">
    <div class="ufp-dialog-container">

      @if (!hasError && !isSuccess) {
        <div class="ufp-dialog-header ufp-position-relative">
          <h2 class="ufp-dialog-title">Booking Confirmation</h2>
          <p class="ufp-dialog-description">Please review your class details</p>
          <button class="ufp-close-button" (click)="onCancel()">×</button>
        </div>
      }

      <div class="ufp-dialog-body">
      <!-- Success State -->
      @if (isSuccess) {
        <div class="ufp-success-state ufp-position-relative">
          <div class="ufp-success-animation">
            <svg class="ufp-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="ufp-checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
              <path class="ufp-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
          <p class="ufp-success-message">{{ successMessage }}</p>
          <button class="ufp-close-button" (click)="onCancel()">×</button>
        </div>
      }

      <!-- Booking Details After Success or Failure -->
      @if (hasError || isSuccess) {
        <!-- Details -->
        <div class="ufp-dialog-booking-details">
          <div class="ufp-booking-flex">
            <div class="ufp-dialog-class-logo">
              <img [src]="data.classItem.type_logo" [alt]="data.classItem.type_name_primary_language">
            </div>
            <div class="ufp-booking-info">
              <h3>{{ data.classItem.type_name_primary_language }}</h3>
              <p class="ufp-dialog-booking-details-date">{{ data.classItem.start_datetime | date:'EEEE, MMMM d, y' }}</p>
              <p class="ufp-dialog-booking-details-time">{{ data.classItem.start_datetime | date:'h:mm a' }}</p>
              <div class="ufp-trainer-info">
                <p class="ufp-trainer-label">Trainer</p>
                <div class="ufp-trainer-row">
                  <div class="ufp-trainer-avatar">
                    @if (data.classItem.coach_image_url) {
                      <img 
                        [src]="data.classItem.coach_image_url" 
                        [alt]="data.classItem.coach_name"
                        (error)="handleImageError($event)">
                    } @else {
                      <div class="ufp-trainer-initials">
                        {{ getCoachInitials(data.classItem.coach_name) }}
                      </div>
                    }
                  </div>
                  <p class="ufp-trainer-name">{{ utils.capitalizeFirstLetter(data.classItem.coach_name) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Details -->

        <!-- Calendar -->
        @if (isSuccess) {
          <div class="ufp-calendar-options">
            <p class="ufp-add-calendar-text">Add to Calendar:</p>
            <div class="ufp-calendar-buttons">
              <button class="ufp-calendar-btn" (click)="addToGoogleCalendar()" aria-label="add-to-google-calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm0 16H5V8h14v12z" fill="currentColor"/>
                </svg>
                Google
              </button>
              <button class="ufp-calendar-btn" (click)="addToAppleCalendar()" aria-label="add-to-apple-calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" fill="currentColor"/>
                </svg>
                Apple
              </button>
              <button class="ufp-calendar-btn" (click)="addToOutlookCalendar()" aria-label="add-to-outlook-calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 4H3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2zm0 3.5L12 13 3 7.5V6l9 5.5L21 6v1.5z" fill="currentColor"/>
                </svg>
                Outlook
              </button>
            </div>
          </div>
        }
        <!-- Calendar -->

      <!-- Footer -->
      @if (isSuccess && hasAppLinks()) {
        <div class="ufp-dialog-footer">
          <p class="ufp-dialog-text-white">Download our Mobile App</p>
          <p>Manage your bookings, track your progress and get exclusive benefits!</p>
          <div class="ufp-dialog-footer-btns">
            @if (data.iosAppLink) {
              <a [href]="data.iosAppLink" target="_blank" class="ufp-app-btn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/></svg>
                <span><small>Download on the</small> App Store</span>
              </a>
            }
            @if (data.androidAppLink) {
              <a [href]="data.androidAppLink" target="_blank" class="ufp-app-btn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/></svg>
                <span><small>Get it on</small> Google Play</span>
              </a>
            }
          </div>
        </div>
      }
      <!-- Footer -->

      }
      <!-- Booking Details After Success or Failure -->

      <!-- Error State -->
      @if (hasError) {
        <div class="ufp-error-state ufp-position-relative">
          <div class="ufp-error-animation">
            <svg class="ufp-crossmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="ufp-crossmark__circle" cx="26" cy="26" r="25" fill="none"/>
              <path class="ufp-crossmark__path" fill="none" d="M16 16 36 36 M36 16 16 36"/>
            </svg>
          </div>
          <p class="ufp-error-message">Booking Failed</p>
          <p class="ufp-error-details ufp-m-0">{{ errorMessage }}</p>
          <button class="ufp-close-button" (click)="onCancel()">×</button>
        </div>
      }
      <!-- Error State -->

      <!-- Confirmation Layout -->
      @if (!hasError && !isSuccess) {
        <div class="ufp-confirmation-layout">
          <div class="ufp-confirmation-main">
            <div class="ufp-confirmation-main-top">
              <div class="ufp-class-hero">
                <div class="ufp-dialog-class-logo">
                  <img [src]="data.classItem.type_logo" [alt]="data.classItem.type_name_primary_language">
                </div>
              </div>

              <div class="ufp-class-summary">
                <div class="ufp-detail-row ufp-detail-row-time">
                  <div class="ufp-icon-container">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <p class="ufp-m-0">{{ data.classItem.start_datetime | date:'h:mm a' }}</p>
                </div>

                <h3 class="ufp-class-title">{{ data.classItem.type_name_primary_language }}</h3>

                <div class="ufp-detail-row">
                  <div class="ufp-icon-container">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="ufp-mt-5px"><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"/></svg>
                  </div>
                  <p class="ufp-date ufp-m-0">{{ data.classItem.start_datetime | date:'EEEE, MMMM d, y' }}</p>
                </div>

                <div class="ufp-detail-row">
                  <div class="ufp-icon-container">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" stroke-width="2"/>
                      <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/>
                    </svg>
                  </div>
                  <p class="ufp-location-address ufp-m-0">{{ data.classItem.tenant_name_primary_language }}</p>
                </div>
              </div>
            </div>

            @if (classDetails?.subtype_description_primary_language; as description) {
              <div class="ufp-class-description ufp-text-gray">
                <h6>Class Description</h6>
                <p class="ufp-m-0">{{ description }}</p>
              </div>
            }
          </div>

          <div class="ufp-coach-section">
            <div class="ufp-coach-card">
              <div class="ufp-d-flex ufp-align-items-center">
                <div class="ufp-coach-image">
                  @if (data.classItem.coach_image_url) {
                    <img 
                      [src]="data.classItem.coach_image_url" 
                      [alt]="data.classItem.coach_name"
                      (error)="handleImageError($event)">
                  } @else {
                    <div class="ufp-coach-initials">
                      {{ getCoachInitials(data.classItem.coach_name) }}
                    </div>
                  }
                </div>
                <div class="ufp-coach-info">
                  <h3 class="ufp-coach-name">{{ utils.capitalizeFirstLetter(data.classItem.coach_name) }}</h3>
                  @if (classDetails?.coach_description; as coachDescription) {
                    <p class="ufp-coach-description">{{ coachDescription }}</p>
                  }
                </div>
              </div>

              @if (classDetails?.public_bio_description_primary_language; as bioDescription) {
                <div class="ufp-coach-bio">
                  <strong class="ufp-d-block">Description</strong>
                  <p class="ufp-d-block ufp-m-0">{{ bioDescription }}</p>
                </div>
              }
              @if (classDetails?.public_bio_achievements_primary_language; as bioAchievements) {
                <div class="ufp-coach-bio">
                  <strong class="ufp-d-block">Achievements</strong>
                  <p class="ufp-d-block ufp-m-0">{{ bioAchievements }}</p>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <!-- Confirmation Layout -->

      </div>
      <!-- dialog-body -->

      <!-- Actions -->
      @if (!isProcessing && !isSuccess && !hasError) {
        <div class="ufp-dialog-actions">
          <!-- <button class="ufp-secondary-btn" (click)="onCancel()">Cancel</button> -->        
          <button class="ufp-confirm-button" (click)="onConfirm()">
            {{ data.isWaitlist ? 'Join Waitlist' : 'Confirm Booking' }}
            <br>
            <small>Only few spots left</small>
          </button>
        </div>
      }
       <!-- Actions -->

      <!-- Processing State -->
      @if (isProcessing) {
        <div class="ufp-processing-state">
          <div class="ufp-spinner"></div>
          <p>Processing your booking...</p>
        </div>
      }
      <!-- Processing State -->

    </div>
  </div>
</div>
